import React from "react";
import cn from "classnames";

const Panel = React.forwardRef(
  ({
    className,
    actions,
    children,
    fullWidth = false,
    ...props
  }, ref) => {
    const baseClass = 'otrl-jp__panel';
    const classes = cn(baseClass, {
      [`${baseClass}--full-width`]: fullWidth
    }, className);

    return (
      <div className={classes} ref={ref} {...props}>
        <div className="otrl-jp__panel__content">
          {children}
        </div>
        {actions && (
          <div className="otrl-jp__panel__actions">
            {actions}
          </div>
        )}
      </div>
    );
  }
);

export default Panel;
